import React from 'react';
import classnames from 'classnames';
import { TThumbnail } from '../UploadingFileThumbnail.types';
import styles from '../UploadingFileThumbnail.scss';

export const Music: TThumbnail = ({ fallbackImageClassName }) => (
  <div className={classnames(styles.contentWrapper, styles.music)} data-hook="uploading-file-thumbnail-music">
    <div className={classnames(styles.content, fallbackImageClassName)} />
  </div>
);
